module.exports = __webpack_public_path__ + "static/portfolio-15-a43c654488aa6b4f8499ce07d63dc0ec.jpg";